import { Drawer, Hidden, useMediaQuery, useTheme } from '@material-ui/core';
import { Menus } from '@models/menu';
import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCollapsed, useMobileOpen } from './MainLayoutContext';
import { MainSideMenuContent } from './MainSideMenuContent';

export const MainSideMenu = ({
  items,
  disabled = false,
  children
}: {
  items: Menus;
  disabled?: boolean;
  children?: ReactNode;
}): React.ReactElement => {
  const [openMobile, setOpenMobile] = useMobileOpen();
  const [collapsed, setCollapsed] = useCollapsed();
  const location = useLocation();

  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (isSmDown && collapsed) {
      setCollapsed(false);
    }
  }, [isSmDown]);

  useEffect(() => {
    if (openMobile && setOpenMobile) {
      setOpenMobile(false);
    }
  }, [location.pathname]);

  return (
    <React.Fragment>
      <Hidden smUp>
        <Drawer onClose={() => setOpenMobile(false)} open={openMobile} anchor='left' variant='temporary'>
          <MainSideMenuContent items={items} disabled={disabled}>
            {children}
          </MainSideMenuContent>
        </Drawer>
      </Hidden>
      <Hidden smDown>
        <Drawer
          PaperProps={{
            style: { height: 'calc(100% - 5rem)', top: '5rem', zIndex: 10, width: collapsed ? '5rem' : '12rem' }
          }}
          anchor='left'
          open
          variant='persistent'
        >
          <MainSideMenuContent items={items} disabled={disabled}>
            {children}
          </MainSideMenuContent>
        </Drawer>
      </Hidden>
    </React.Fragment>
  );
};
